var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { WorkspaceStatus } from '@lucidlink/dto/validation';
import { LIMITS_STATUSES } from '@lucidlink/sdk';
import { AlertTriangleIcon, Label, LockIcon, Tooltip, translate, useTooltip, } from '@lucidlink/uicore';
import { useCurrentMemberByWorkspaceId, useGetWorkspaceLoginStatus, } from '#query-hooks';
export const WorkspaceStatusLabel = ({ limitsStatus, workspaceId, workspaceStatus, }) => {
    _react_refresh_temp_2();
    const { query: { data: currentMemberData }, } = useCurrentMemberByWorkspaceId(workspaceId);
    const { query: { data: workspaceLoginStatus }, } = useGetWorkspaceLoginStatus(workspaceId);
    const { isTooltipActive: isLimitsTooltipActive, tooltipProps: limitsTooltipProps, triggerProps: limitsTriggerProps, } = useTooltip({ placement: 'right' });
    const isLimitReached = useMemo(() => limitsStatus?.members === LIMITS_STATUSES.REACHED ||
        limitsStatus?.storage === LIMITS_STATUSES.REACHED ||
        limitsStatus?.trial === LIMITS_STATUSES.REACHED, [limitsStatus?.members, limitsStatus?.storage, limitsStatus?.trial]);
    const isLimitApproaching = useMemo(() => limitsStatus?.members === LIMITS_STATUSES.APPROACHING ||
        limitsStatus?.storage === LIMITS_STATUSES.APPROACHING ||
        limitsStatus?.trial === LIMITS_STATUSES.APPROACHING, [limitsStatus?.members, limitsStatus?.storage, limitsStatus?.trial]);
    if (workspaceLoginStatus?.mfaRequirement === 'required') {
        return (_jsx(Label, { color: "static_info", "data-testid": "trial-label", size: "small", StartIcon: LockIcon, text: translate('2FA') }));
    }
    if (workspaceStatus === WorkspaceStatus.TRIALING) {
        if (currentMemberData?.privileges?.billing &&
            (isLimitApproaching || isLimitReached)) {
            return (_jsxs(_Fragment, { children: [_jsx(Label, { color: "static_error", "data-testid": "trial-label", size: "small", StartIcon: AlertTriangleIcon, text: translate('Trial'), ...limitsTriggerProps }), isLimitsTooltipActive && (_jsx(Tooltip, { contents: [
                            isLimitReached
                                ? translate('You have reached the limits of your workspace. View details in Billing & invoices.')
                                : translate('You are approaching the limits of your workspace. View details in Billing & invoices.'),
                        ], tooltipProps: limitsTooltipProps }))] }));
        }
        else {
            return (_jsx(Label, { color: "static_1", "data-testid": "trial-label", size: "small", text: translate('Trial') }));
        }
    }
    else if (workspaceStatus === WorkspaceStatus.SUSPENDED) {
        return (_jsx(Label, { color: "static_error", "data-testid": "suspended", size: "small", StartIcon: AlertTriangleIcon, text: translate('Suspended') }));
    }
    else {
        return null;
    }
};
_react_refresh_temp_1 = WorkspaceStatusLabel;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceStatusLabel");
_react_refresh_temp_2(WorkspaceStatusLabel, "FxlkXnzXS05r7+RK9Em+B/0zMsk=", false, () => [useCurrentMemberByWorkspaceId, useGetWorkspaceLoginStatus, useTooltip]);
